import React, { ReactNode } from 'react';

import { IconWarning2, IconX } from '..';

interface WarningModalBodyProps {
    /**
     * Main content of modal
     */
    children: ReactNode;
    /**
     * Height of modal
     * @defaultValue 500
     */
    height?: number;
    /**
     * Called when user clicks on the X icon
     */
    onClose?(): void;
    /**
     * Width of modal
     * @defaultValue 800
     */
    width?: number;
}

/**
 * A wrapper for the content of a modal, styled with an orange border and warning icon.
 * @param props - {@link WarningModalBodyProps}
 */
export const WarningModalBody = ({
    children,
    height = 500,
    onClose,
    width = 800,
}: WarningModalBodyProps): JSX.Element => (
    <div
        className="rounded-lg bg-white p-10 border-l-4 border-quinary-500 grid"
        style={{
            width,
            height,
            gridTemplateColumns: '50px auto 20px',
        }}
    >
        <IconWarning2 fillColor="quinary-500" width={40} />
        <div className="h-full">{children}</div>
        {onClose && (
            <button type="button" onClick={onClose}>
                <IconX width={20} fillColor="tertiary-400" />
            </button>
        )}
    </div>
);
